<template>
  <div class="login-container">
    <div class="login-title">用户登录</div>
    <Form ref="paasFormValidate" :model="paasFormValidate" :rules="paasFormRules" :label-width="100" class="login-form">
      <div class="ivu-row">
        <FormItem label="账号:" prop="accountLogin" class="ivu-col-span-24">
          <Input v-model="paasFormValidate.accountLogin" placeholder="账号"></Input>
        </FormItem>
      </div>
      <div class="ivu-row">
        <FormItem label="密码:" prop="password" class="ivu-col-span-24">
          <Input v-model="paasFormValidate.password" placeholder="密码" :type="'password'"></Input>
        </FormItem>
      </div>
      <div class="ivu-row login-error-info" v-show="showLoginErrorInfo">
        用户名或密码错误，请重试！
      </div>
      <div class="ivu-row">
        <Button type="primary" class="login-btn" icon="md-checkmark" @click="login">登录</Button>
      </div>
    </Form>
  </div>
</template>

<script>
  let Base64 = require('js-base64').Base64;
  export default {
    name: "login",
    data() {
      return {
        paasFormValidate: {
          accountLogin: '',
          password: '',
          loginWay: 'account',
          loginType: 'web'
        },
        paasFormRules: {
          accountLogin: [
            {required: true, trigger: 'blur'}
          ],
          password: [
            {required: true, trigger: 'blur'}
          ]
        },
        showLoginErrorInfo: false
      }
    },
    created() {
      // 主页添加键盘事件,注意,不能直接在焦点事件上添加回车
      let that = this;
      document.onkeydown = (e) => {
        let key = window.event.keyCode;
        if(key===13){
          that.login();
        }
      }
    },
    methods: {
      login() {
        let me = this;
        this.$refs.paasFormValidate.validate((valid) => {
          if(valid) {
            let loginInfo = {
              accountLogin: me.paasFormValidate.accountLogin,
              password: Base64.encode(me.paasFormValidate.password),
              loginType: me.paasFormValidate.loginType,
              loginWay: me.paasFormValidate.loginWay
            };
            me.axios.post(me.$store.state.sysApi+"/login", loginInfo).then(function (req) {
              if(req.code === 200) {
                me.$store.commit('setTopMenu',req.data.menus); //顶级节点
                me.$store.commit('setModuleChild',req.data.moduleChildMap); //模块对应子模块
                me.$store.commit('setModuleFunc',req.data.moduleFuncMap); //末级模块对应的子功能
                me.$store.commit('setFuncOperMap',req.data.funcOperMap); //功能操作map
                me.$store.commit('setFirstModule',req.data.firstModule); //第一个末级模块
                me.$store.commit('setFirstFunc',req.data.firstFunc); //末级模块的第一个功能
                me.$store.commit('setDefaultFuncId',req.data.firstFunc.id);//登陆时重定向的功能Id
                me.$store.commit("setLoginToken",req.data.loginToken);

                window.localStorage.setItem("topMenu", JSON.stringify(req.data.menus));
                window.localStorage.setItem("moduleChildMap", JSON.stringify(req.data.moduleChildMap));
                window.localStorage.setItem("moduleFuncMap", JSON.stringify(req.data.moduleFuncMap));
                window.localStorage.setItem("funcOperMap", JSON.stringify(req.data.funcOperMap));
                window.localStorage.setItem("firstModule", JSON.stringify(req.data.firstModule));
                window.localStorage.setItem("firstFunc", JSON.stringify(req.data.firstFunc));
                window.localStorage.setItem("defaultFuncId", req.data.firstFunc.id);
                window.sessionStorage.setItem("loginToken", req.data.loginToken);

                me.$router.push({path: '/main'});


              }
            }).catch(err => {
                //me.$Message.error(err.data.message);
            })
          }
        });
      },
      /**
       * enter键直接登录
       * @param e
       */
      enterKeyLogin(){
        alert("11");
      }
    },
  }
</script>

<style scoped>
  .login-container {
    width: 500px;
    margin: 0 auto;
  }
  .login-title {
    height: 40px;
    line-height: 40px;
    width: 100%;
    vertical-align: middle;
    text-align: center;
  }
  .login-form {
    padding: 10px;
  }
  .login-btn {
    width: 60%;
    margin-left: 20%;
  }
  .login-error-info {
    color: red;
    font-size: 13px;
    height: 40px;
    line-height: 40px;
    vertical-align: middle;
    text-align: center;
  }
</style>
